import type { IAppsSdkDescriptionItemDto } from "../types/dto";

export function getAllSdkCategories(descriptions: readonly IAppsSdkDescriptionItemDto[]): readonly string[] {
    const categories = new Set<string>();

    descriptions.forEach(({ categories: sdkCategories }) => {
        sdkCategories.forEach((category) => categories.add(category));
    });

    return Array.from(categories);
}

export function toggleName(list: readonly string[], name: string): readonly string[] {
    return list.includes(name) ? list.filter((item) => item !== name) : [...list, name];
}
